<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="refundinfo" :rules="rules" ref="refundrule" label-width="120px" class="">
			<el-row>
				<el-col :span="22">
					<el-form-item label="订单编号" prop="orderno">
						<el-input clearable v-model="refundinfo.orderno" :disabled="true"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22">					
					<el-form-item label="退款来源" prop="refundsource">
						<el-select clearable style="width: 100%;" v-model="refundinfo.refundsource" filterable placeholder="请选择退款来源">
							<el-option v-for="item in refundsourceList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22">
					<el-form-item label="退款原因" prop="reason">
						<el-input clearable v-model="refundinfo.reason" maxlength="20"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="22">
					<el-form-item label="退款金额" prop="amount" >
						<el-input-number style="width: 100%;" v-model="refundinfo.amount" :precision="2" :min="0.01" :max="2000" label="退款金额"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">取消</el-button>
			<el-button type="primary" @click="saveRefund">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { refundOrder,queryRefundDetail } from '/static/apiUrl.js'
	export default {
		name : 'OrderRefund',
		data() {
			return {
				editok : false,
				refundinfo : {
					"userpwd": "",
					"orderno": "",
					"reason": "",
					"amount": 0,
					"refundsource": "",
				},	
				refundsourceList : [
					{
						label : '平台原因',
						value : 'platformrefund',
					},
					{
						label : '商家原因',
						value : 'businessrefund',
					},
				],	
				rules: {
					reason : [
						{ required: true, message: '请输入退款原因', trigger: 'blur' }
					],
					amount : [
						{ required: true, message: '请输入退款金额', trigger: 'blur'},
						{ type: 'number', min: 0.01, max: 2000, message: '退款金额在0.01~2000之间', trigger: ['change','blur'] }
					],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			orderno : {
				type: String,
				required: false
			},
		},
		watch: {
			orderno: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.clearData()
					this.refundinfo.orderno = newVal;
					this.refundDetail(newVal);
				}
			},
		},
		methods: {
			clearData(){
				this.refundinfo = {
					"userpwd": "",
					"orderno": "",
					"reason": "",
					"amount": 0,
					"refundsource": "",
				}
				this.editok = false
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
			refundDetail(orderno){
				if(orderno !== undefined && orderno !== null && orderno != ''){
					queryRefundDetail({orderno : orderno}).then(res => {
						if(0 == res.code){
							this.refundinfo.amount = res.data.amount
						}
					})
				}
			},
			saveRefund() {
				this.$refs["refundrule"].validate((valid) => {			
					if (valid) {
						this.$prompt('请输入您的密码', '提示', {
							inputType: 'password',
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(({ value }) => {
							this.refundinfo.userpwd = this.$md5(value)
							refundOrder(this.refundinfo).then(res => {
									console.log(res)
									if(0 == res.code){
										//this.editok = true
										this.clearData()
										this.$emit("needRefrash",true,false)
										this.$message.success("订单退款成功")
									}else{
										this.$emit("needRefrash",false,true)
										this.$message.error(res.msg)
									}
								})
						}).catch(() => { });
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>